import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type {
  TicketKind,
  TicketListItem,
  TicketPriority,
  TicketStatus,
} from '@/features/stacktrace/tickets/-query/type';

/**
 * チケット 一覧（QA Force グローバルメニュー）のテーブル列ID。
 *
 * 表示項目:
 *   コード / タイトル / 種別 / ステータス / 優先度 / プロダクト /
 *   対象プロダクション / 期限日 / 担当者
 */
export const TicketTableColumns = {
  CODE: 'CODE',
  TITLE: 'TITLE',
  KIND: 'KIND',
  STATUS: 'STATUS',
  PRIORITY: 'PRIORITY',
  PRODUCT: 'PRODUCT',
  TARGET_PRODUCTION: 'TARGET_PRODUCTION',
  DUE_DATE: 'DUE_DATE',
  ASSIGNEES: 'ASSIGNEES',
} as const;
export type TicketTableColumns = EnumUnion<typeof TicketTableColumns>;

type TicketCodeColumn = {
  id: string;
  code: string;
};

type TicketProductColumn = {
  id: string;
  name: string;
};

type TicketProductionColumn = {
  id: string;
  name: string;
} | null;

type TicketAssigneeColumn = {
  personId: string;
  name: string;
  role: string | null;
};

export type TicketTableRowData = {
  [TicketTableColumns.CODE]: TicketCodeColumn;
  [TicketTableColumns.TITLE]: string;
  [TicketTableColumns.KIND]: TicketKind | undefined;
  [TicketTableColumns.STATUS]: TicketStatus | undefined;
  [TicketTableColumns.PRIORITY]: TicketPriority | undefined;
  [TicketTableColumns.PRODUCT]: TicketProductColumn;
  [TicketTableColumns.TARGET_PRODUCTION]: TicketProductionColumn;
  [TicketTableColumns.DUE_DATE]: string | null;
  [TicketTableColumns.ASSIGNEES]: TicketAssigneeColumn[];
};

export const convertTicketItemToTableRow = (
  item: TicketListItem,
): TicketTableRowData => {
  return {
    [TicketTableColumns.CODE]: { id: item.id, code: item.code },
    [TicketTableColumns.TITLE]: item.title,
    [TicketTableColumns.KIND]: item.kind as TicketKind | undefined,
    [TicketTableColumns.STATUS]: item.status as TicketStatus | undefined,
    [TicketTableColumns.PRIORITY]: item.priority as TicketPriority | undefined,
    [TicketTableColumns.PRODUCT]: {
      id: item.productId,
      name: item.productName,
    },
    [TicketTableColumns.TARGET_PRODUCTION]:
      item.targetProductionId && item.targetProductionName
        ? { id: item.targetProductionId, name: item.targetProductionName }
        : null,
    [TicketTableColumns.DUE_DATE]: item.dueDate,
    [TicketTableColumns.ASSIGNEES]: item.assignees,
  };
};
